import { styled } from '@mui/material';
import { PartialOptions } from 'overlayscrollbars';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

import { scrollerStyles } from './constants';
import { ScrollerProps, ScrollerRef } from './types';
import { WithRef } from '../../types';

const ScrollerBase = ({
  ref,
  options: scrollOptions,
  ...rest
}: WithRef<ScrollerRef, ScrollerProps>) => {
  const options: PartialOptions = {
    ...(scrollOptions || {}),
    scrollbars: {
      autoHide: 'move',
      ...(scrollOptions || {})?.scrollbars,
      theme: 'os-theme-dark os-theme-custom',
    },
  };
  return <OverlayScrollbarsComponent ref={ref} options={options} {...rest} />;
};

ScrollerBase.displayName = 'ScrollerBase';

const Scroller = styled(ScrollerBase)(({ theme }) => ({
  ...scrollerStyles(theme),
}));

Scroller.displayName = 'Scroller';

export default Scroller;
